/* istanbul ignore file */
export enum CreditType {
  PHOTOGRAPHER = 'photographer',
  ARTIST = 'artist',
  AUTHOR = 'author',
  VOICE = 'voice',
  OWNER = 'owner',
  ILLUSTRATOR = 'illustrator',
  MOVIE = 'movie',
}
